import React, { useState, useEffect } from "react";
import ReactSpeedometer from "react-d3-speedometer";
import "./App.css"; // Import the CSS file

const MyGauge = ({ totalWeightage = 0 }) => {
  const targetValue = totalWeightage || 0;
  const minValue = 0;
  const maxValue = 100;

  const [animatedValue, setAnimatedValue] = useState(0); // State for animated value

  // Animate the blob's movement from 0 to the target value
  useEffect(() => {
    let currentValue = 0;
    const interval = setInterval(() => {
      currentValue += 1; // Increment the value
      if (currentValue > targetValue) {
        clearInterval(interval); // Stop the animation when the target value is reached
      } else {
        setAnimatedValue(currentValue); // Update the animated value
      }
    }, 10); // Adjust the speed of the animation (lower is faster)

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [targetValue]);

  // Calculate the angle for the blob based on the animated value
  const angle = ((animatedValue - minValue) / (maxValue - minValue)) * Math.PI; // Map value to 0-π radians
  const adjustedAngle = angle - Math.PI; // Ensure it starts exactly at -π for 0%
   // Dynamically adjust the radius based on the animatedValue
const getDynamicRadius = () => {
  if (animatedValue <= 5) return 155; // Radius for 0-5
  if (animatedValue <= 40) return 156;
  if (animatedValue <= 60) return 160; // Radius for 5-60
  if (animatedValue <= 70) return 165; // Radius for 60-70
  if (animatedValue <= 80) return 167; // Radius for 70-80
  return 172; // Radius for 80-100
};

const radius = getDynamicRadius(); // Get the dynamic radius
  const ringWidth = 38; // Thickness of the gauge arc
  const blobRadiusAdjustment = ringWidth / 3; // Adjust the blob's position to center it on the arc

  // Calculate the blob's position
  const blobX = (radius - blobRadiusAdjustment) * Math.cos(adjustedAngle); // X-coordinate
  const blobY = (radius - blobRadiusAdjustment) * Math.sin(adjustedAngle); // Y-coordinate

  // Determine the blob's color based on the animated value
  const getBlobColor = () => {
    if (animatedValue <= 70) return "#F06B4B"; // Red
    if (animatedValue <= 90) return "#F5C956"; // Yellow
    return "#48C497"; // Green
  };

  return (
    <div  style={{
      display: "flex",
      flexDirection: "column",
      marginTop: "25px",
    }}>
    <div>
    <h3 className="card-title">Vendor Score</h3>
    <hr className="divider" />
    </div>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        flexDirection: "column",
      }}
    >
  
      <ReactSpeedometer
        value={animatedValue}
        minValue={minValue}
        maxValue={maxValue}
        segments={3} // Three segments for the new color ranges
        needleHeightRatio={0.0} // Completely hide the default needle
        customSegmentStops={[0, 70, 90, 100]} // Define custom stops
        segmentColors={["#F06B4B", "#F5C956", "#48C497"]} // Updated colors
        ringWidth={ringWidth} // Adjust the thickness of the gauge
        needleTransitionDuration={4000} // Smooth transition
        needleTransition="easeElastic"
        textColor="FFFFFF" // Hide the default numbers (0, 70, 90, 100)
        forceRender={true} // Force re-render for smooth updates
        width={380} // Increase the width of the meter
        height={210} // Increase the height of the meter
      />
      
      {/* Blob */}
      <div
  style={{
    position: "absolute",
    width: "45px", // Slightly larger blob
    height: "45px",
    backgroundColor: getBlobColor(), // Dynamic color based on animated value
    borderRadius: "50%",
    left: `calc(48% + ${blobX}px)`, // Adjust X position relative to the center
    top: `calc(88% + ${blobY}px)`, // Adjust Y position relative to the center
    transform: "translate(-50%, -50%)", // Center the blob
    border: "2px solid white", // Add a white border for better visibility
    boxShadow: "0 0 10px rgba(255, 255, 255, 0.5)", // Add a glow effect
  }}
></div>
      {/* Display Value */}
      <div
        style={{
          position: "absolute",
          top: "80%", // Move slightly above the center
          left: "50%", // Center horizontally
          transform: "translate(-50%, -50%)", // Center the text
          fontSize: "48px", // Slightly smaller font size
          color:'#333',
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {animatedValue}
        <label style={{ fontSize: "20px", color: "#333" }}>
         vendor score
        </label>
      </div>
    </div>
    </div>
  );
};

export default MyGauge;